import {Configuration} from 'core/configuration'; // keep me at the top to ensure logger get's tagged before any dependency uses it
import React from 'react';
import ReactDOM from 'react-dom/client';
import DefaultTheme from "@vacasa/react-components-lib/src/themes/default";
import {ImplicitFlow, ThemeProvider} from "@vacasa/react-components-lib";
import AppRoutes from './appRoutes';
import { ToastSuccess, ToastError } from 'components/toast/Toast'
import { SnackbarProvider } from 'notistack';
import {Provider} from "react-redux";
import {store} from "store/store";
import 'styles/base.scss';
import ConfigProvider from 'ConfigProvider';

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

/**
 * Get the directory hint from the URL parameters
 * If the directory hint is not "onelogin" or "authentik", set it to undefined
 * @returns {string | undefined}
 */
const ALLOWED_DIRECTORY_HINTS = ['onelogin', 'authentik'];
function getDirectoryHintFromUrl(): string | undefined {
    const hint = new URLSearchParams(window.location.search).get('directory_hint');
    return hint && ALLOWED_DIRECTORY_HINTS.includes(hint)? hint : undefined;
}

const implicitFlowConfig = Configuration.implicitFlowConfig(getDirectoryHintFromUrl());

root.render(
  <React.Fragment>
        <ThemeProvider theme={DefaultTheme}>
            <ImplicitFlow {...implicitFlowConfig} followRedirect={true}>
                <Provider store={store}>
                    <SnackbarProvider
                        Components={{
                            success: ToastSuccess,
                            error: ToastError
                        }}
                        anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                    />
                    <ConfigProvider>
                        <AppRoutes />
                    </ConfigProvider>
                </Provider>
            </ImplicitFlow>
        </ThemeProvider>
  </React.Fragment>
);
